import { UtilisateurListItem } from 'lauria/types/utilisateur'

export function getUtilisateurDisplayLabel(
  utilisateur: Pick<UtilisateurListItem, 'prenom' | 'nom'>
): string {
  return `${utilisateur.prenom ?? ''} ${utilisateur.nom ?? ''}`.trim()
}
